import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import Backend from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

const getPreferredLanguage = () => {
  // 1. Check Telegram WebApp language (both new and old methods)
  const telegramLang = window.Telegram?.WebApp?.lang || 
                      window.Telegram?.WebApp?.language_code ||
                      (() => {
                        try {
                          const initData = new URLSearchParams(window.Telegram?.WebApp?.initData || '');
                          const user = JSON.parse(initData.get('user') || {});
                          return user.language_code;
                        } catch {
                          return null;
                        }
                      })();

  // 2. Return Telegram language if detected
  if (telegramLang) {
    return telegramLang.startsWith('ru') ? 'ru' : 'en';
  }

  // 3. Fallback to browser language
  const browserLang = navigator.language || 'en';
  return browserLang.startsWith('ru') ? 'ru' : 'en';
};

i18n
  .use(Backend)
  .use(initReactI18next)
 // .use(LanguageDetector)
  .init({
    lng: getPreferredLanguage() || 'en',
    fallbackLng: 'en',
    supportedLngs: ['en', 'ru'],
    preload: ['en', 'ru'],
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },
    interpolation: {
      escapeValue: false,
    }
  });

export default i18n;